import { z } from './utils/zod.js';
import { deleteResponse, successResponse } from './utils/response-templates.js';
export const createApiKeyRequestSchema = z.object({
    name: z.string().trim().min(1).max(150),
});
export const apiKeyDtoSchema = z.object({
    id: z.string().uuid(),
    name: z.string().max(150),
    organizationId: z.string().uuid(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    createdById: z.string().uuid(),
    key: z.string().max(255),
});
export const createApiKeyResponseSchema = successResponse().extend({
    data: apiKeyDtoSchema,
});
export const apiKeyListItemSchema = z.object({
    id: z.string().uuid(),
    name: z.string().max(150),
    organizationId: z.string().uuid(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const listApiKeysResponseSchema = successResponse().extend({
    data: z.array(apiKeyListItemSchema),
});
export const cancelApiKeyResponseSchema = deleteResponse();
